"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Browse: "Examinar",
  Change: "Cambiar",
  "Drop your image here": "Suelte su imagen aquí",
  "Drop your logo here": "Suelte su logotipo aquí",
  Remove: "Quitar",
  "Revert to default": "Revertir a valores predeterminados",
  "Sorry, \"{fileName}\" is larger than {maxFileSize} and can't be uploaded. Please upload a file that's {maxFileSize} or smaller.": ['Lo sentimos, "', ["fileName"], '" es mayor que ', ["maxFileSize"], " y no se puede cargar. Cargue un archivo de ", ["maxFileSize"], " o de menor tamaño."],
  "Sorry, \"{fileName}\" is smaller than {minFileSize} and can't be uploaded. Please upload a file that's {minFileSize} or larger.": ['Lo sentimos, "', ["fileName"], '" es de menor tamaño que ', ["minFileSize"], " y no se puede cargar. Cargue un archivo de ", ["minFileSize"], " o de mayor tamaño."],
  "Sorry, this image format isn't supported. Please provide a {fileTypes}.": ["Lo sentimos, este formato de imagen no es compatible. Proporcione un ", ["fileTypes"], "."],
  "Unsupported file type": "Tipo de archivo no compatible"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map